import React from 'react'
import LogoImg from '../../images/logo.png'

const Logo = props => {
  return <img alt="Logo" src={LogoImg} {...props} style={{ width: '110px' }} />
}

export default Logo
